import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { genOptionsTranslation } from 'src/app/core/utils/common-functions';

@Component({
  selector: 'laas-table-column-toggle',
  templateUrl: './table-column-toggle.component.html',
  styleUrls: ['./table-column-toggle.component.scss']
})

export class TableColumnToggleComponent implements OnInit {

  @Input() optionsColumn: any;
  @Input() dataTable: any;
  @Input() confirmEmitControl: boolean = false;

  @Output() onToggleConfirm: EventEmitter<any> = new EventEmitter<any>();

  translateService: TranslateService;

  constructor(injector: Injector) {
    this.translateService = injector.get(TranslateService);
  }

  onConfirm() {
    if(this.confirmEmitControl) {
      this.onToggleConfirm.emit();
    } else {
      this.dataTable.saveState();
    }
  }

  ngOnInit(): void {
    this.optionsColumn = genOptionsTranslation(this.translateService, this.optionsColumn);
  }

}
